import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const SecurityBadge = () => (
  <div className="flex items-center gap-1 rounded-md border px-2 py-1">
    <Icon name="lock" size="sm" color="tertiary" />
    <Typography variant="label-xs" color="tertiary">
      {t("paywall_checkout.form.safe_and_secure")}
    </Typography>
  </div>
);
